const determineAddonFrequency = (pricingType) => {
  return pricingType.includes('per night') ? 'PERDAY' : 'ONCE';
};

export default determineAddonFrequency;
